
import React from 'react';
import PlanBudgetInfoComponent from './plan-budget-info.component';
import PlanSmsInfoComponent, { PlanNoteComponent } from './plan-note-info.component';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';

export const PlanInfoComponent = ({
  campaignFrequency,
  choosenPlan,
  planBudget,
  planNotes,
  handleInnerFormChange,
}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Budget',
        component:   <PlanBudgetInfoComponent
        planBudget={planBudget}
        handleInnerFormChange={handleInnerFormChange}
      />,
    isVisible:true ,
    },
    {
      id:2,
      title:'Notes',
      component: <PlanNoteComponent
      planNotes={planNotes}
      handleInnerFormChange={handleInnerFormChange}      
    />,
    isVisible:true,
  },]
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
              <InputContainer
                label="Name"
                labelField="Name"
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(event.target.value, 'Name');
                }}
                type="text"
                value={choosenPlan?.Name}
              />
           
              <InputContainer
                label="Campaign Frequency"
                labelField="Text"
                list={campaignFrequency}
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'CampaignFrequencyId',
                  );
                }}
                optionName='Choose Campaign Frequency '
                type="select"
                value={choosenPlan?.CampaignFrequencyId}
                valueField="Value"
              />
           
              <InputContainer
                isDateTimePicker
                label="Start Date"
                name="StartDate"
                onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'StartDate');
                }}
                type="date"
                value={choosenPlan?.StartDate}
              />
           
              <InputContainer
                isDateTimePicker
                label="End Date"
                name="EndDate"
                onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'EndDate');
                }}
                type="date"
                value={choosenPlan?.EndDate}
              />
           </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
      />

      {/* <AccordionContainer
        child={
          <TabContainer tabItems={tabItems} />
        }
        expandedPanel="Plan Budget and Note Info"
        headerTitle="Plan Budget and Note Info"
      /> */}

      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
              <InputContainer
                label="SMS"
                name="IsSMSCampaignIncluded"
                onValueChange={(event: any) => {
                  handleInnerFormChange(event, 'IsSMSCampaignIncluded');
                }}
                type="checkbox"
                value={choosenPlan?.IsSMSCampaignIncluded}
              />
          
              <InputContainer
                label="Email"
                name="IsEmailCampaignIncluded"
                onValueChange={(event: any) => {
                  handleInnerFormChange(event, 'IsEmailCampaignIncluded');
                }}
                type="checkbox"
                value={choosenPlan?.IsEmailCampaignIncluded}
              />
{/*            
              <InputContainer
                label="Whatsapp"
                name="IsWhatsappCampaignIncluded"
                onValueChange={(event: any) => {
                  handleInnerFormChange(event, 'IsWhatsappCampaignIncluded');
                }}
                type="checkbox"
                value={choosenPlan?.IsWhatsappCampaignIncluded}
              /> */}
           
              {/* <InputContainer
                label="FaceBook"
                name="IsFacebookCampaignIncluded"
                onValueChange={(event: any) => {
                  handleInnerFormChange(event, 'IsFacebookCampaignIncluded');
                }}
                type="checkbox"
                value={choosenPlan?.IsFacebookCampaignIncluded}
              /> */}
           </div>
        }
        expandedPanel="Campaign Modes"
        headerTitle="Campaign Modes"
      />
    </>
  );
};
export default PlanInfoComponent;
